/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import Checkbox from "@mostrans/web-components/components/base/Checkbox";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import Select from "@mostrans/web-components/components/base/Select";
import { Box, Dialog, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSetState } from "react-use";
import {
  createCandidateEducation,
  updateCandidateEducationByID,
} from "../../../../graphql/mutations";
import { getCandidateByID } from "../../../../graphql/query";
import { toastError, toastSuccess } from "../../../../shared/helpers";
import { listPendidikan } from "../../../../shared/listPendidikan";
import { years } from "../../../../shared/listYears";
import { useSetRecoilState } from "recoil";
import { globalLoadingAtom } from "../../../../shared/globalStates";

export default function Education({ open, setOpen, handleClose, data, setData, index }) {
  const client = useApolloClient();
  const [edit, setEdit] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false);
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const [isCurrentEducation, setIsCurrentEducation] = useState(false);
  const [values, setValues] = useSetState({
    id: "",
    school_name: "",
    major: "",
    graduate_year: "",
    start_year: "",
    ipk: "",
    degree: "",
    is_current: isCurrentEducation,
  });

  useEffect(() => {
    if (open[1]) {
      setValues({
        id: data.Educations[index].id,
        school_name: data.Educations[index].school_name,
        major: data.Educations[index].major,
        graduate_year: data.Educations[index].graduate_year,
        start_year: data.Educations[index].start_year,
        ipk: data.Educations[index].ipk,
        degree: data.Educations[index].degree,
        is_current: data.Educations[index].is_current,
      });
      setIsCurrentEducation(data.Educations[index].is_current);
    } else {
      setValues({
        id: "",
        school_name: "",
        major: "",
        graduate_year: "",
        start_year: "",
        ipk: "",
        degree: "",
        is_current: false,
      });
      setIsCurrentEducation(false);
    }
  }, [data, open]);

  useEffect(() => {
    if (data.length !== 0) {
      handleEdited();
      return;
    }
    setEdit(false);
  }, [values]);

  const handleEdited = () => {
    if (
      !open[1] &&
      (!values.degree ||
        (isCurrentEducation ? values.graduate_year : !values.graduate_year) ||
        !values.start_year ||
        !values.ipk ||
        !values.major ||
        !values.school_name)
    )
      return setEdit(true);
    if (data.Educations === null) return setEdit(false);
    if (
      values.id !== data?.Educations[index]?.id ||
      values.school_name !== data?.Educations[index]?.school_name ||
      values.major !== data?.Educations[index]?.major ||
      (values.is_current
        ? values.graduate_year === null &&
          data.Educations[index]?.graduate_year !== values.graduate_year
        : values.graduate_year !== data.Educations[index]?.graduate_year) ||
      values.start_year !== data?.Educations[index]?.start_year ||
      values.ipk !== data?.Educations[index]?.ipk ||
      values.degree !== data?.Educations[index]?.degree
    ) {
      setEdit(false);
    } else {
      setEdit(true);
    }
  };

  const handleSubmit = async () => {
    if (
      !values.degree ||
      (isCurrentEducation ? values.graduate_year !== null : !values.graduate_year) ||
      (values.graduate_year && values.start_year > values.graduate_year) ||
      !values.start_year ||
      !values.ipk ||
      values.ipk.length > 4 ||
      !values.major ||
      !values.school_name
    ) {
      setIsEmpty(true);
    } else {
      if (open[1]) {
        setLoading(true);
        values.ipk = parseFloat(values.ipk);
        const result = await updateCandidateEducationByID(client, values);
        if (result.status !== "000") {
          toastError(result.errMsg);
        } else {
          setIsCurrentEducation(false);
          toastSuccess("Edit Education Success");
          setOpen([false, false]);
          getCandidateByID(client).then(setData);
        }
        setLoading(false);
      } else {
        setLoading(true);
        delete values.id;
        values.ipk = parseFloat(values.ipk);
        const result = await createCandidateEducation(client, values);
        if (result.status !== "000") {
          toastError(result.errMsg);
        } else {
          setIsCurrentEducation(false);
          toastSuccess("Add Education Success");
          setOpen([false, false]);
          getCandidateByID(client).then(setData);
        }
        setLoading(false);
      }
    }
  };

  const handleIsCurrentEducation = () => {
    setIsCurrentEducation(!isCurrentEducation);
    setValues({ graduate_year: null, is_current: !isCurrentEducation });
  };

  return (
    <React.Fragment>
      <Button
        variant="text"
        color="primary"
        size="small"
        type="tertiary"
        onClick={() => setOpen([true, false])}
        startIcon={<span className="material-icons"> add </span>}
        sx={{ fontSize: "14px" }}>
        Add Education
      </Button>
      <Dialog open={open[0]} onClose={handleClose}>
        <Box>
          <Box p={2}>
            <Typography variant="h4">{open[1] ? "EDIT" : "ADD"} EDUCATION</Typography>
          </Box>
          <Divider />
          <Box p={2}>
            <Grid container spacing={1}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <FormGroup
                  className="font-size-main"
                  label="Qualification"
                  errorMessage={"Qualification cannot be empty!"}
                  isError={isEmpty && !values.degree}
                  isRequired
                  showChildErrorSign>
                  <Select
                    id="qualification"
                    name="qualification"
                    maxMenuHeight={150}
                    value={values.degree && { label: values.degree }}
                    placeholder="Select Qualification"
                    onChange={(e) => {
                      setValues({ degree: e.value.toUpperCase() });
                    }}
                    options={listPendidikan.map((value) => ({
                      value: value,
                      label: value,
                    }))}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <FormGroup
                  className="font-size-main"
                  label="Name of University/School"
                  errorMessage={"Name of University/School cannot be empty"}
                  isError={isEmpty && !values.school_name}
                  isRequired
                  showChildErrorSign>
                  <Input
                    id="school_name"
                    name="school_name"
                    value={values.school_name}
                    onChange={(e) =>
                      setValues({
                        school_name: e.target.value.toUpperCase(),
                      })
                    }
                    type="text"
                    placeholder="Enter Name of University/School"
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={4} lg={4} md={4} sm={4} xs={8}>
                <FormGroup
                  className="font-size-main"
                  label="Major"
                  errorMessage={"Major cannot be empty"}
                  isError={isEmpty && !values.major}
                  isRequired
                  showChildErrorSign>
                  <Input
                    id="major"
                    name="major"
                    value={values.major}
                    onChange={(e) => setValues({ major: e.target.value.toUpperCase() })}
                    type="text"
                    placeholder="Enter Major"
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={2} xs={4}>
                <FormGroup
                  className="font-size-main"
                  label="IPK/Grade"
                  errorMessage={values.ipk?.length > 4 ? "IPK too long" : "IPK cannot be empty"}
                  isError={(isEmpty && !values.ipk) || values.ipk?.length > 4}
                  isRequired
                  showChildErrorSign>
                  <Input
                    id="ipk"
                    name="ipk"
                    value={values.ipk ? values.ipk : ""}
                    onChange={(e) => {
                      const regex = /^[0-9\d.]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        setValues({
                          ipk: e.target.value,
                        });
                      }
                    }}
                    type="number"
                    maxLength={5}
                    placeholder="Enter IPK"
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <Grid container spacing={1}>
                  <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                    <FormGroup
                      className=" font-size-main"
                      label="Start Year"
                      errorMessage={"Start year cannot be empty"}
                      isError={isEmpty && !values.start_year}
                      isRequired
                      showChildErrorSign>
                      <Select
                        id="start_year"
                        name="start_year"
                        maxMenuHeight={150}
                        menuPlacement="top"
                        value={
                          values.start_year && {
                            label: values.start_year,
                          }
                        }
                        placeholder="Select"
                        onChange={(e) =>
                          setValues({
                            start_year: e.value,
                          })
                        }
                        options={years().map((value) => ({
                          value: value,
                          label: value,
                        }))}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                    <FormGroup
                      className=" font-size-main"
                      label="End Year"
                      errorMessage={
                        isEmpty && !isCurrentEducation && !values.graduate_year
                          ? "End year cannot be empty"
                          : values.graduate_year &&
                            values.start_year > values.graduate_year &&
                            "End year cannot be earlier than start year"
                      }
                      isError={
                        (isEmpty && !isCurrentEducation && !values.graduate_year) ||
                        Boolean(values.graduate_year && values.start_year > values.graduate_year)
                      }
                      isRequired
                      showChildErrorSign>
                      <Select
                        id="graduate_year"
                        name="graduate_year"
                        isDisabled={isCurrentEducation}
                        maxMenuHeight={150}
                        menuPlacement="top"
                        value={
                          values.graduate_year && {
                            label: values.graduate_year,
                          }
                        }
                        placeholder="Select"
                        onChange={(e) =>
                          setValues({
                            graduate_year: e.value,
                          })
                        }
                        options={years().map((value) => ({
                          value: value,
                          label: value,
                        }))}
                      />
                    </FormGroup>
                  </Grid>
                  <FormGroup
                    className="ml-1 font-size-small justify-content-end"
                    placement="horizontal"
                    label="Currently i'm still studying here">
                    <Checkbox
                      size="small"
                      checked={isCurrentEducation}
                      onClick={() => handleIsCurrentEducation()}
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Divider />
          <Box p={2} textAlign="end">
            <Button
              onClick={() => setOpen([false, false])}
              variant="outlined"
              color="danger"
              style={{ margin: "0 10px" }}>
              Cancel
            </Button>
            <Button disabled={edit} onClick={handleSubmit} style={{ margin: "0 10px" }}>
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
